import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/projects", label: "Projects" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header" data-testid="site-header">
      <nav className="nav-shell" aria-label="Primary">
        <Link to="/" aria-label="SUV Engineers home" data-testid="brand-home-link">
          <img className="brand-logo" src="/assets/suvlogo.png" alt="SUV Engineers" />
        </Link>
        <button
          className="menu-toggle"
          type="button"
          aria-expanded={open}
          aria-label="Toggle menu"
          onClick={() => setOpen((o) => !o)}
          data-testid="menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
        <div className={`nav-links ${open ? "open" : ""}`} id="primary-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn btn-copper btn-sm nav-cta" onClick={() => setOpen(false)} data-testid="nav-quote-btn">
            Get a Quote <ArrowUpRight size={16} />
          </Link>
        </div>
      </nav>
    </header>
  );
}
